import React, { useEffect, useState } from 'react';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import StudioFooter from './StudioFooter';
import './StudioHome.css';
import './StudioPortfolio.css';

const StudioPortfolioShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname]);

  return (
    <div className="studio-site studio-portfolio-site" id="top">
      <header className="studio-header">
        <div className="studio-header-inner">
          <Link className="studio-brand" to="/" aria-label="솜니움라이브 홈">
            <img src="/brand-concepts/som/shift-05a-register.svg" alt="" />
            <span>솜니움라이브</span>
          </Link>
          <nav className="studio-nav" aria-label="주 메뉴">
            <a href="/#work">포트폴리오</a>
            <a href="/#service">제작 서비스</a>
            <a href="/#approach">진행 방식</a>
          </nav>
          <a className="studio-header-cta" href="/#contact">프로젝트 문의 <FiArrowUpRight /></a>
          <button className="studio-menu-button" type="button" aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'} aria-expanded={menuOpen} onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
        {menuOpen && (
          <nav className="studio-mobile-nav" aria-label="모바일 메뉴">
            <Link to="/portfolio" onClick={() => setMenuOpen(false)}>전체 포트폴리오</Link>
            <a href="/#work">메인 작업 목록</a>
            <a href="/#service">제작 서비스</a>
            <a href="/#approach">진행 방식</a>
            <a href="/#contact">프로젝트 문의</a>
          </nav>
        )}
      </header>
      {children}
      <StudioFooter />
    </div>
  );
};

export default StudioPortfolioShell;
